<table class="timing-table table-auto w-full">
	<thead class="bg-surface-container text-on-surface-container text-xs sticky top-0 text-left">
		<tr>
			<th class="details-toggle-header"></th>
			<th class="position-arrow-col"></th>
			<th class="text-left">P</th>
			<th class="text-center">#</th>
			<th>Car</th>
			<th>Team/Driver</th>
			<th class="text-right">Pic</th>
			<th class="text-right">Lap</th>
			@if (raceSessionService.gapByClass) {
				<th class="text-right">Gap</th>
				<th class="text-right">Class Gap</th>
				<th class="text-right">Interval</th>
			} @else {
				<th class="text-right">Gap</th>
				<th class="text-right">Interval</th>
			}
			<th class="text-right">Last Lap</th>
			<th class="text-right">Best Lap</th>
			<th class="text-right">S1</th>
			<th class="text-right">S2</th>
			<th class="text-right">S3</th>
			<th class="text-right">Pits</th>
			<th class="text-right">Max Speed</th>
		</tr>
	</thead>
	<tbody class="text-sm">
		<ng-container *ngFor="let team of teams(); trackBy: trackByFn">
			<tr
				class="hover:bg-surface-container-high"
				[ngClass]="timingTowerService.activeList().includes(team?.number) ? activeClass() : ''"
				[class.has-playback]="team?.playback?.url"
				[class.team-row-moved-up]="positionChangeStateByNumber()[team?.number ?? ''] === 'up'"
				[class.team-row-moved-down]="positionChangeStateByNumber()[team?.number ?? ''] === 'down'"
				(click)="toggleTeamSelection(team!)"
			>
				<td class="details-toggle-cell">
					<button
						type="button"
						class="details-toggle-button"
						(click)="toggleDrawer(team, $event)"
						aria-label="Toggle team details"
						[attr.aria-expanded]="isDrawerOpen(team)"
					>
						<svg
							class="details-toggle-icon"
							[ngClass]="{ 'is-open': isDrawerOpen(team) }"
							viewBox="0 0 20 20"
							fill="none"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
							aria-hidden="true"
						>
							<polyline points="7 4 13 10 7 16"></polyline>
						</svg>
					</button>
				</td>
				<td class="position-arrow-col">
					<vb-lxp-position-change-indicator
						[state]="positionChangeStateByNumber()[team?.number ?? ''] || 'neutral'"
					></vb-lxp-position-change-indicator>
				</td>
				<td>
					<span
						class="text-right timing-position-value"
						[ngClass]="
							timingTowerService.activeList().includes(team?.number) ? activeNumberClass() : ''
						"
						>{{ team?.activeStanding?.position }}</span
					>
				</td>
				<td>
					<div
						class="rounded-sm px-1 flex items-center justify-center"
						[title]="team?.class"
						[style.background-color]="team?.classDetails?.background"
						[style.color]="team?.classDetails?.foreground"
					>
						<span>{{ team?.number }}</span>
					</div>
				</td>
				<td>
					<img
						class="w-6 h-6 object-contain"
						[src]="team?.manufacturer || team?.vehicle || '' | teamLogoLookup: team?.class"
						alt="Logo"
						[title]="team?.manufacturer || team?.vehicle"
					/>
				</td>
				<td>
					<div class="team-driver-line">
						<span class="flex timing-driver-name">
							{{ team?.currentDriverFullName }}
						</span>
					</div>
					<div class="team-name">{{ team?.team }}</div>
				</td>
				<td class="text-right">{{ team?.classStanding?.position }}</td>
				<td class="text-right">{{ team?.participantDetails?.currentLap }}</td>
				@if (raceSessionService.gapByClass) {
					<td class="timing-data-bold">
						@if (team?.activeStanding?.gapFirstLaps > 0) {
							{{ team?.activeStanding?.gapFirstLaps }}L
						} @else {
							+{{
								team?.activeStanding?.gapFirstTime
									? (team?.activeStanding?.gapFirstTime || 0 | timespanShort)
									: '0.000'
							}}
						}
					</td>
					<td class="timing-data-bold">
						@if (team?.classStanding?.gapFirstLaps > 0) {
							{{ team?.classStanding?.gapFirstLaps }}L
						} @else {
							+{{
								team?.classStanding?.gapFirstTime
									? (team?.classStanding?.gapFirstTime || 0 | timespanShort)
									: '0.000'
							}}
						}
					</td>
					<td class="timing-data-bold">
						@if (team?.activeStanding?.gapPreviousLaps > 0) {
							{{ team?.activeStanding?.gapPreviousLaps }}L
						} @else {
							+{{
								team?.activeStanding?.gapPreviousTime
									? (team?.activeStanding?.gapPreviousTime || 0 | timespanShort)
									: '0.000'
							}}
						}
					</td>
				} @else {
					<td class="timing-data-bold">
						@if (team?.activeStanding?.gapFirstLaps > 0) {
							{{ team?.activeStanding?.gapFirstLaps }}L
						} @else {
							+{{
								team?.activeStanding?.gapFirstTime
									? (team?.activeStanding?.gapFirstTime || 0 | timespanShort)
									: '0.000'
							}}
						}
					</td>
					<td class="timing-data-bold">
						@if (team?.activeStanding?.gapPreviousLaps > 0) {
							{{ team?.activeStanding?.gapPreviousLaps }}L
						} @else {
							+{{
								team?.activeStanding?.gapPreviousTime
									? (team?.activeStanding?.gapPreviousTime || 0 | timespanShort)
									: '0.000'
							}}
						}
					</td>
				}
				<td class="timing-data-bold timing-last-lap">
					<span [ngClass]="team?.lastLapClass">
						{{ team?.participantDetails?.lastLap?.time | timespanMs }}
					</span>
				</td>
				<td class="timing-data-bold">{{ team?.participantDetails?.bestLap?.time | timespanMs }}</td>
				<td class="timing-data-bold">
					@if (team?.currentLapSectorData[1]) {
						<span [ngClass]="team?.currentLapSectorData[1].className">
							{{ team?.currentLapSectorData[1].time | timespanShort }}
						</span>
					} @else {
						<span>--</span>
					}
				</td>
				<td class="timing-data-bold">
					@if (team?.currentLapSectorData[2]) {
						<span [ngClass]="team?.currentLapSectorData[2].className">
							{{ team?.currentLapSectorData[2].time | timespanShort }}
						</span>
					} @else {
						<span>--</span>
					}
				</td>
				<td class="timing-data-bold">
					@if (team?.currentLapSectorData[3]) {
						<span [ngClass]="team?.currentLapSectorData[3].className">
							{{ team?.currentLapSectorData[3].time | timespanShort }}
						</span>
					} @else {
						<span>--</span>
					}
				</td>
				<td class="text-right">{{ team.participantDetails?.pitStops }}</td>
				<td class="text-right text-speed" [class.text-secondary]="team.isTopSpeedOverall">
					{{ team.participantDetails.bestTopSpeed * 0.621371 | number: '1.1-1' }}
					@if (team.participantDetails.bestTopSpeed) {
						mph
					} @else {
						--
					}
				</td>
			</tr>
			<tr class="drawer-row" [class.is-open]="isDrawerOpen(team)">
				<td [attr.colspan]="raceSessionService.gapByClass ? 18 : 17">
					<vb-lxp-timing-tower-drawer
						[team]="team"
						[isOpen]="isDrawerOpen(team)"
					></vb-lxp-timing-tower-drawer>
				</td>
			</tr>
		</ng-container>
	</tbody>
</table>
